/**
 * Server Configuration Service - SIMPLIFIED
 * Hanya membaca dari window.APP_CONFIG (config.js)
 * Tidak ada localStorage, tidak ada UI konfigurasi
 */

/**
 * Get API base URL dari config.js
 * Otomatis menambahkan /api jika belum ada
 */
export function getApiBaseUrl(): string {
  let baseUrl = ''

  // Baca dari window.APP_CONFIG (config.js)
  if (typeof window !== 'undefined' && (window as any).APP_CONFIG?.API_BASE_URL) {
    baseUrl = (window as any).APP_CONFIG.API_BASE_URL
  } else {
    // Fallback ke localhost jika config.js tidak ada
    console.warn('[serverConfig] window.APP_CONFIG tidak ditemukan, menggunakan localhost')
    baseUrl = 'http://localhost/api'
  }

  // Remove trailing slashes
  baseUrl = baseUrl.replace(/\/+$/, '')

  // Add /api if not already present
  if (!baseUrl.endsWith('/api')) {
    baseUrl = `${baseUrl}/api`
  }

  return baseUrl
}

// Backward compatibility - fungsi lama yang masih digunakan
export function getServerUrl(): string {
  const apiUrl = getApiBaseUrl()
  // Remove /api suffix untuk compatibility
  return apiUrl.replace(/\/api$/, '')
}

export function isServerConfigured(): boolean {
  // Selalu return true karena config.js selalu ada
  return true
}

export default {
  getApiBaseUrl,
  getServerUrl,
  isServerConfigured,
}
